// extracted by mini-css-extract-plugin
module.exports = {"linkCard":"linkCard_linkCard__3UlLc","linkCard__icon":"linkCard_linkCard__icon__24mu8"};